<script setup lang="ts">
import type { BecomeAuthorData } from '~/utils/crystallize/become-author'

defineProps<{
  data: NonNullable<BecomeAuthorData['components']>['authors']
}>()
</script>

<template>
  <section v-if="data?.title || data?.description || data?.persons?.length" class="bg-moss-500 text-white py-10 md:py-20 lg:py-44">
    <ContentGrid>
      <div class="col-span-full lg:col-span-6 lg:col-start-2 2xl:col-span-8 2xl:col-start-3 flex flex-col gap-10 md:gap-20">
        <section v-if="data.title || data.description" class="flex flex-col justify-center gap-s md:gap-l relative">
          <h2 v-if="data.title" class="text-moss-200 title-xl" v-text="data.title" />
          <CrystallizeRichText v-for="(block, i) in data.description" :key="i" class="text-lg" :block="block" />
        </section>
        <section v-if="data.persons?.length" class="flex flex-col gap-m md:gap-xl">
          <h3 v-if="data.secondaryTitle" class="text-moss-200 title-l !font-light" v-text="data.secondaryTitle" />

          <ul class="flex flex-col gap-m md:gap-l">
            <BecomeAuthorCard v-for="({ person }, i) in data.persons" :key="person?.name ?? i" :person="person" />
          </ul>
        </section>
      </div>
    </ContentGrid>
  </section>
</template>
